export default __webpack_public_path__ + "19a4f3a6883bb606f0b19035c7edef2c.svg";